"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./DuTrendUtils";

export default function DuCorrectScoresSection({ title, correctScoresFull }) {
  const { home = [], draw = [], away = [] } = correctScoresFull || {};
  const allScores = [...home, ...draw, ...away];

  if (allScores.length === 0) return null;

  return (
    <div className="du-ods-detail-item kbv-hbet-odt-card ods-100">
      <div className="du-odstb-title kbv-hbet-odt-txt">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="du-odstb-odds-list du-scores-grid">
        {home.map((item, i) => (
          <div key={`h${i}`}>
            <div className="du-title-odds">{item.label}</div>
            <div className="score-values">
              <div
                className={`du-odds kbv-hbet-odt-odds ods-100 du-ods-white ${trendClass(
                  item.trend,
                )}`}
              >
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div
                  className={`du-odds ods-100 du-ods-white ${trendClass(
                    item.trend2,
                  )}`}
                >
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        {draw.map((item, i) => (
          <div key={`d${i}`}>
            <div className="du-title-odds">{item.label}</div>
            <div className="score-values">
              <div
                className={`du-odds kbv-hbet-odt-odds ods-100 du-ods-white ${trendClass(
                  item.trend,
                )}`}
              >
                {displayValue(item.value)}
              </div>
            </div>
          </div>
        ))}
        {away.map((item, i) => (
          <div key={`a${i}`}>
            <div className="du-title-odds">{item.label}</div>
            <div className="score-values">
              <div
                className={`du-odds kbv-hbet-odt-odds ods-100 du-ods-white ${trendClass(
                  item.trend,
                )}`}
              >
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div
                  className={`du-odds ods-100 du-ods-white ${trendClass(
                    item.trend2,
                  )}`}
                >
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        <div>
          <div className="du-title-odds">AOS</div>
          <div className="score-values">
            <div className="du-odds kbv-hbet-odt-odds ods-100 du-ods-white">-</div>
          </div>
        </div>
      </div>
    </div>
  );
}

